/* ══════════════════════════════════════════════════════════════
   Hindi (hi) — हिन्दी Translation File
   ══════════════════════════════════════════════════════════════ */

export const hi = {
    app: {
        name: 'इंडिया मार्केट मॉनिटर',
        tagline: 'AI-संचालित भारतीय बाज़ार बुद्धिमत्ता',
    },
    nav: {
        dashboard: 'डैशबोर्ड',
        strategy: 'रणनीति',
        intelligence: 'इंटेलिजेंस',
        markets: 'बाज़ार',
        indiaMap: 'भारत का नक्शा',
        ipoEarnings: 'IPO और आय',
        backtest: 'बैकटेस्ट',
        settings: 'सेटिंग्स',
        search: 'कंपनी, समाचार, रणनीति खोजें…',
    },
    dashboard: {
        title: 'डैशबोर्ड',
        marketStatus: 'बाज़ार स्थिति',
        open: 'खुला',
        closed: 'बंद',
        preOpen: 'प्री-ओपन',
        holiday: 'छुट्टी',
        strategyCard: 'आज की रणनीति',
        marketRadar: 'मार्केट रडार',
        fiiDii: 'FII / DII प्रवाह',
        quickStats: 'त्वरित आँकड़े',
        newsTicker: 'प्राथमिकता समाचार',
        liveTV: 'लाइव टीवी',
        viewDetails: 'विवरण देखें →',
        updatedAt: '{{time}} पर अपडेट',
    },
    strategy: {
        title: 'रणनीति',
        regime: 'बाज़ार रीजीम',
        regimeTypes: {
            trendingBull: 'तेज़ी का रुझान',
            trendingBear: 'मंदी का रुझान',
            sideways: 'साइडवेज़ / रेंज',
            highVol: 'उच्च अस्थिरता',
        },
        confidence: 'विश्वास',
        entry: 'प्रवेश',
        target: 'लक्ष्य',
        stopLoss: 'स्टॉप लॉस',
        riskReward: 'जोखिम : पुरस्कार',
        signal: 'सिग्नल',
        buy: 'खरीदें',
        sell: 'बेचें',
        hold: 'होल्ड',
        featureImportance: 'फ़ीचर महत्व',
        topDrivers: 'आज के शीर्ष 10 ड्राइवर',
        totalFeatures: '{{count}} कुल फ़ीचर गणना',
        performance: 'मॉडल प्रदर्शन',
        accuracy: 'सटीकता',
        healthy: 'स्वस्थ',
        warning: 'चेतावनी',
        degraded: 'गिरावट',
        keyLevels: 'मुख्य स्तर',
        support: 'सपोर्ट',
        resistance: 'रेसिस्टेंस',
        pivotPoint: 'पिवट पॉइंट',
        currentPrice: 'वर्तमान मूल्य',
        strategyDetail: 'रणनीति विवरण',
        commentary: 'AI टिप्पणी',
        sectors: 'संबंधित क्षेत्र',
    },
    intelligence: {
        title: 'इंटेलिजेंस',
        morningBrief: 'मॉर्निंग ब्रीफ',
        priorityFeed: 'प्राथमिकता फ़ीड',
        sectorIntel: 'क्षेत्र इंटेलिजेंस',
        earningsTracker: 'आय',
        eventTimeline: 'घटनाएँ',
        newsSearch: 'खोजें',
        briefTitle: 'AI मॉर्निंग ब्रीफ',
        briefDate: '{{date}} • प्री-मार्केट विश्लेषण',
        keyPoints: 'मुख्य बिंदु',
        overnightGlobal: 'रातोंरात वैश्विक',
        todayWatch: 'आज की निगरानी',
        sectorOutlook: 'क्षेत्र दृष्टिकोण',
        source: 'स्रोत',
        impact: 'प्रभाव',
        critical: 'गंभीर',
        high: 'उच्च',
        medium: 'मध्यम',
        low: 'निम्न',
        whyItMatters: 'यह क्यों मायने रखता है',
        sentiment: 'भावना',
        bullish: 'तेज़ी',
        bearish: 'मंदी',
        neutral: 'तटस्थ',
    },
    markets: {
        title: 'बाज़ार',
        indices: 'सूचकांक',
        options: 'ऑप्शंस',
        sectors: 'क्षेत्र',
        commodities: 'कमोडिटी',
        currency: 'मुद्रा',
        breadth: 'ब्रेड्थ',
        nifty50: 'निफ्टी 50',
        sensex: 'सेंसेक्स',
        bankNifty: 'बैंक निफ्टी',
        week52Range: '52 सप्ताह: {{low}} – {{high}}',
        optionsChain: 'ऑप्शंस चेन',
        strike: 'स्ट्राइक',
        pcr: 'PCR',
        maxPain: 'मैक्स पेन',
        sectorHeatmap: 'क्षेत्र हीटमैप',
        change: 'बदलाव',
        volume: 'वॉल्यूम',
        advancing: 'बढ़ते हुए',
        declining: 'घटते हुए',
        unchanged: 'अपरिवर्तित',
        adRatio: 'A/D अनुपात',
    },
    ipo: {
        title: 'IPO और आय',
        dashboard: 'IPO डैशबोर्ड',
        earningsTracker: 'आय ट्रैकर',
        upcoming: 'आगामी IPO',
        live: 'लाइव IPO सब्सक्रिप्शन',
        listed: 'हाल में सूचीबद्ध',
        issueSize: 'इश्यू साइज़',
        priceBand: 'मूल्य बैंड',
        opens: 'खुलता है',
        closes: 'बंद होता है',
        gmp: 'GMP',
        subscription: 'सब्सक्रिप्शन',
        retail: 'रिटेल',
        subscribe: 'सब्सक्राइब करें',
        avoid: 'टालें',
        wait: 'इंतज़ार करें',
        revenue: 'राजस्व',
        pat: 'PAT',
        verdict: 'निर्णय',
        beat: 'बीट',
        miss: 'मिस',
        inline: 'इनलाइन',
    },
    backtest: {
        title: 'बैकटेस्ट',
        equityCurve: 'इक्विटी कर्व',
        riskMetrics: 'जोखिम मेट्रिक्स',
        monthlyReturns: 'मासिक रिटर्न',
        regimeBreakdown: 'रीजीम ब्रेकडाउन',
        tradeLog: 'ट्रेड लॉग',
        totalReturn: 'कुल रिटर्न',
        cagr: 'CAGR',
        sharpe: 'शार्प',
        maxDrawdown: 'अधिकतम गिरावट',
        winRate: 'जीत दर',
        trades: 'ट्रेड्स',
    },
    map: {
        title: 'भारत का नक्शा',
        selectState: 'राज्य चुनें',
        gdp: 'GDP',
        growth: 'वृद्धि',
        keySectors: 'प्रमुख क्षेत्र',
    },
    settings: {
        title: 'सेटिंग्स',
        appearance: 'दिखावट',
        theme: 'थीम',
        darkMode: 'डार्क मोड',
        lightMode: 'लाइट मोड',
        language: 'भाषा',
        selectLanguage: 'भाषा चुनें',
        currentLanguage: 'वर्तमान: {{lang}}',
        about: 'के बारे में',
    },
    fiiDii: {
        fii: 'FII',
        dii: 'DII',
        net: 'नेट',
        today: 'आज',
        fiveDay: '5-दिन',
        thirtyDay: '30-दिन',
        buyingStreak: 'FII {{count}} लगातार दिन खरीद रहे',
        sellingStreak: 'FII {{count}} लगातार दिन बेच रहे',
        mixed: 'FII मिश्रित गतिविधि',
        source: 'स्रोत: NSDL/CDSL',
    },
    radar: {
        title: 'मार्केट रडार',
        score: '{{score}}/10',
        buy: 'खरीदें',
        hold: 'होल्ड',
        sell: 'बेचें',
    },
    sectorRotation: {
        title: 'क्षेत्र रोटेशन',
        leading: 'अग्रणी',
        weakening: 'कमज़ोर',
        lagging: 'पिछड़ा',
        improving: 'सुधार',
        relativeStrength: 'सापेक्ष शक्ति',
        momentum: 'गति',
        oneMonth: '1 माह',
        threeMonth: '3 माह',
        sixMonth: '6 माह',
    },
    election: {
        title: 'चुनाव प्रभाव',
        upcomingElections: 'आगामी चुनाव',
        state: 'राज्य',
        expectedDate: 'अपेक्षित तिथि',
        incumbent: 'मौजूदा',
        historicalImpact: 'ऐतिहासिक निफ्टी प्रभाव',
        priorDays: '30 दिन पहले',
        electionWeek: 'चुनाव सप्ताह',
        afterDays: '30 दिन बाद',
        sectorImpact: 'क्षेत्र प्रभाव (यदि पार्टी जीतती है)',
        avgReturn: 'औसत निफ्टी रिटर्न',
    },
    budget: {
        title: 'बजट प्रभाव',
        unionBudget: 'केंद्रीय बजट 2026-27',
        countdown: 'उल्टी गिनती',
        daysLeft: '{{days}} दिन शेष',
        historicalReaction: 'ऐतिहासिक बजट दिवस निफ्टी',
        sectorAllocation: 'क्षेत्र आवंटन परिवर्तन (YoY)',
        increase: 'वृद्धि',
        decrease: 'कमी',
        keyAnnouncements: 'प्रमुख नीतिगत घोषणाएँ',
        sectorWiseImpact: 'क्षेत्र-वार प्रभाव',
        positiveFor: 'सकारात्मक',
        negativeFor: 'नकारात्मक',
    },
    common: {
        loading: 'लोड हो रहा है…',
        error: 'कुछ गलत हुआ',
        retry: 'पुनः प्रयास',
        noData: 'कोई डेटा उपलब्ध नहीं',
        viewAll: 'सभी देखें',
        close: 'बंद करें',
        save: 'सहेजें',
        cancel: 'रद्द करें',
        yes: 'हाँ',
        no: 'नहीं',
        crore: 'करोड़',
        lakh: 'लाख',
        rupee: '₹',
        percent: '%',
        positive: 'सकारात्मक',
        negative: 'नकारात्मक',
        lastUpdated: 'अंतिम अपडेट: {{time}}',
        marketHours: 'बाज़ार समय: सुबह 9:15 – दोपहर 3:30 IST',
        disclaimer: 'यह वित्तीय सलाह नहीं है। केवल जानकारी के लिए।',
    },
};
